import { useUserGetWrong } from '../../api/hooks/User/useUserGetWrong'
import { useUserStore } from '../../store/useUserStore'
import styles from '../../styles/admin/SignIn.module.scss'

const SummaryBox = () => {
  const { userProfile } = useUserStore()

  const { data: wrongData, isLoading } = useUserGetWrong({
    ID: userProfile?.ID || 0,
  })

  if (isLoading) {
    return <div className={styles.loading}>Loading summary...</div>
  }

  const wrongCount = wrongData?.wrongCount || 0
  const totalQuestions = wrongData?.totalQuestions || 0
  const correctCount = totalQuestions - wrongCount

  return (
    <div className={styles.summaryBox}>
      <h2 className={styles.title}>Quiz Summary</h2>

      <div className={styles.resultsWrapper}>
        <div className={styles.resultItem}>
          <span className={styles.label}>Total Questions:</span>
          <span className={styles.value}>{totalQuestions}</span>
        </div>

        <div className={styles.resultItem}>
          <span className={styles.label}>Correct Answers:</span>
          <span className={`${styles.value} ${styles.correct}`}>
            {correctCount}
          </span>
        </div>

        <div className={styles.resultItem}>
          <span className={styles.label}>Wrong Answers:</span>
          <span className={`${styles.value} ${styles.wrong}`}>
            {wrongCount}
          </span>
        </div>

        <div className={styles.scoreWrapper}>
          <span className={styles.scoreLabel}>Score:</span>
          <span className={styles.score}>
            {totalQuestions > 0
              ? Math.round((correctCount / totalQuestions) * 100)
              : 0}
            %
          </span>
        </div>
      </div>
    </div>
  )
}

export default SummaryBox
